<template>
  <button type="button" :class="['accordion-toggler', { 'accordion-toggler--is-open': isOpen }]" @click="$emit('click')">
    <oie-use-svg svg="circle-plus" :class="{'svg--45': isOpen}"></oie-use-svg>
    {{ text }}
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion-toggler {
  @include reset-button;
  @include h3-semi-bold;
  overflow: hidden;
}

.accordion-toggler > svg {
  margin-right: measure(half);
  transition: transform 140ms;
}
</style>
